import Heading from "common/components/Typography/Heading/Heading";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from './CargaNotasView.module.scss';
import CargaNotasForm from "../../Forms/CargaNotasForm/CargaNotasForm";

import { useDispatch } from "react-redux";
import { retrieveCatalogs } from "modules/bussiness_logic/actions/catalogActions";
import { useSelector } from "react-redux";
import ReciboPapelForm from "../../Forms/ReciboPapelForm/ReciboPapelForm";


export default function CargaEstadoCuentaView(props){
     const { type } = useParams();
    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(retrieveCatalogs());
    },[dispatch]);
   
    const {catalogs} = useSelector((state)=> {
            return state;
    });

    // if (!["factura","recibo"].includes(type)) return <div className={styles.viewwrapper}>
    //         Error. 
    //     </div>;

    return <div className={styles.viewwrapper}>
        <div>
           
            <Heading variant="h2" override>
                {"Recepcion de: Notas de Debito"}    
            </Heading> 
            {<CargaNotasForm />}
        </div>
    </div>;
}